import algoliasearch from 'algoliasearch'

export const searchClient = algoliasearch(
  'X6I9UWVU91',
  '4f4ab531d852f217ffd70c5e16314d87',
)
